/* eslint-disable no-param-reassign */
import createSlice, { PayloadAction } from '@lumapps/redux/createSlice';

export interface UnreadCountsState {
    sources: Record<string, number>;
}

const initialState: UnreadCountsState = {
    sources: {},
};

const { actions, reducer } = createSlice({
    domain: 'unreadCounts',
    initialState,
    reducers: {
        registerUnreadCount: (state: UnreadCountsState, action: PayloadAction<{ source: string; count: number }>) => {
            state.sources[action.payload.source] = action.payload.count;
        },
        unregisterUnreadCount: (state: UnreadCountsState, action: PayloadAction<string>) => {
            delete state.sources[action.payload];
        },
    },
});

export { actions, reducer };

export const selectTotalUnreadCount = (state: { unreadCounts?: UnreadCountsState }): number =>
    Object.values(state.unreadCounts?.sources ?? {}).reduce((sum, count) => sum + count, 0);
